const SuppliersApp = () => {
    return <h3>SuppliersApp</h3>
}

export default SuppliersApp;